export function getBaseURL(): string {
  const urlParams = new URLSearchParams(window.location.search);
  const tenant = urlParams.get('tenant');

  // Highest priority is the environment variable
  if (process.env.API_URL) {
    return `${process.env.API_URL}`;
  }

  // If the tenant is 'rpde', point to their single tenant
  if (tenant === 'rpde') {
    return 'https://pbc.roedl.com';
  }

  // Default URL
  return 'https://app.auditi.de';
}
